/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Empty_Norange_Description2Inputs */

const id_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba pilih rentang tanggal yang berbeda di atas.`)
};

const ms_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba pilih julat tarikh yang berbeza di atas.`)
};

const da_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv at vælge et andet datointerval ovenfor.`)
};

const de_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuchen Sie, oben einen anderen Datumsbereich auszuwählen.`)
};

const en_us2_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try selecting a different date range above.`)
};

const es_es2_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba a seleccionar otro rango de fechas arriba.`)
};

const es_mx2_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intenta seleccionar un rango de fechas diferente arriba.`)
};

const fil_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subukang pumili ng ibang date range sa itaas.`)
};

const fr_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayez de sélectionner une autre plage de dates ci-dessus.`)
};

const it_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova a selezionare un intervallo di date diverso qui sopra.`)
};

const hu_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próbálj más dátumtartományt választani fent.`)
};

const nl_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probeer een ander datumbereik hierboven te selecteren.`)
};

const no_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv å velge et annet datoområde over.`)
};

const pl_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spróbuj wybrać inny zakres dat powyżej.`)
};

const pt_br2_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente selecionar um período diferente acima.`)
};

const pt_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente selecionar um intervalo de datas diferente acima.`)
};

const ro_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încearcă să selectezi un interval de date diferit mai sus.`)
};

const fi_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokeile valita toinen päivämääräväli yllä.`)
};

const sv_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Försök välja ett annat datumintervall ovan.`)
};

const vi_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãy thử chọn một phạm vi ngày khác ở trên.`)
};

const tr_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yukarıdan farklı bir tarih aralığı seçmeyi deneyin.`)
};

const cs_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkuste vybrat jiný rozsah dat výše.`)
};

const bg_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опитайте да изберете друг диапазон от дати по-горе.`)
};

const ru_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте выбрать другой диапазон дат выше.`)
};

const uk_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спробуйте вибрати інший діапазон дат вище.`)
};

const ar_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حاول اختيار نطاق تاريخ مختلف أعلاه.`)
};

const hi_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऊपर कोई भिन्न तारीख़ सीमा चुनने का प्रयास करें।`)
};

const th_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองเลือกช่วงวันที่อื่นด้านบน`)
};

const ja_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上の日付範囲を変更してみてください。`)
};

const zh_cn2_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请尝试选择上方不同的日期范围。`)
};

const zh_hant1_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請嘗試在上方選擇不同的日期範圍。`)
};

const ko_components_performancetable_empty_norange_description2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`위에서 다른 날짜 범위를 선택해 보세요.`)
};

/**
* | output |
* | --- |
* | "Try selecting a different date range above." |
*
* @param {Components_Performancetable_Empty_Norange_Description2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_empty_norange_description2 = /** @type {((inputs?: Components_Performancetable_Empty_Norange_Description2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Empty_Norange_Description2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_empty_norange_description2(inputs)
	if (locale === "ms") return ms_components_performancetable_empty_norange_description2(inputs)
	if (locale === "da") return da_components_performancetable_empty_norange_description2(inputs)
	if (locale === "de") return de_components_performancetable_empty_norange_description2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_empty_norange_description2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_empty_norange_description2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_empty_norange_description2(inputs)
	if (locale === "fil") return fil_components_performancetable_empty_norange_description2(inputs)
	if (locale === "fr") return fr_components_performancetable_empty_norange_description2(inputs)
	if (locale === "it") return it_components_performancetable_empty_norange_description2(inputs)
	if (locale === "hu") return hu_components_performancetable_empty_norange_description2(inputs)
	if (locale === "nl") return nl_components_performancetable_empty_norange_description2(inputs)
	if (locale === "no") return no_components_performancetable_empty_norange_description2(inputs)
	if (locale === "pl") return pl_components_performancetable_empty_norange_description2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_empty_norange_description2(inputs)
	if (locale === "pt") return pt_components_performancetable_empty_norange_description2(inputs)
	if (locale === "ro") return ro_components_performancetable_empty_norange_description2(inputs)
	if (locale === "fi") return fi_components_performancetable_empty_norange_description2(inputs)
	if (locale === "sv") return sv_components_performancetable_empty_norange_description2(inputs)
	if (locale === "vi") return vi_components_performancetable_empty_norange_description2(inputs)
	if (locale === "tr") return tr_components_performancetable_empty_norange_description2(inputs)
	if (locale === "cs") return cs_components_performancetable_empty_norange_description2(inputs)
	if (locale === "bg") return bg_components_performancetable_empty_norange_description2(inputs)
	if (locale === "ru") return ru_components_performancetable_empty_norange_description2(inputs)
	if (locale === "uk") return uk_components_performancetable_empty_norange_description2(inputs)
	if (locale === "ar") return ar_components_performancetable_empty_norange_description2(inputs)
	if (locale === "hi") return hi_components_performancetable_empty_norange_description2(inputs)
	if (locale === "th") return th_components_performancetable_empty_norange_description2(inputs)
	if (locale === "ja") return ja_components_performancetable_empty_norange_description2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_empty_norange_description2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_empty_norange_description2(inputs)
	return ko_components_performancetable_empty_norange_description2(inputs)
});
export { components_performancetable_empty_norange_description2 as "components.performanceTable.empty.noRange.description" }